import {
  createRequestTypes,
  createActions,
} from 'app/store/actions/base-request.actions'

export const KNOWLEDGE_BUILDERS_ACTIONS = createRequestTypes(
  '[Media] KNOWLEDGE BUILDERS'
)

export const KNOWLEDGE_BUILDER_ACTIONS = createRequestTypes(
  '[Media] KNOWLEDGE BUILDER'
)

export const knowledgeBuildersActionCreators = createActions(
  KNOWLEDGE_BUILDERS_ACTIONS
)

export const knowledgeBuilderActionCreators = createActions(
  KNOWLEDGE_BUILDER_ACTIONS
)
